const getImageBaseLink = () => `${window.imgUrl}${window.businessId}/`;

export default getImageBaseLink;
